import { date2str, DATETIME_FORMAT, TIME_FORMAT, str2date } from '@/utils/format';
const SHORT_DATETIME_FORMAT_24H = '%m/%d %H:%M';
const SHORT_DATETIME_FORMAT_12H = '%m/%d %h:%M #ampm';

const SHORT_TIME_FORMAT_24H = '%H:%M';
const SHORT_TIME_FORMAT_12H = '%h:%M #ampm';

export const FIRST_AVAILABLE_ID = 'firstAvailableId';
export const WEEKLY_AVAILABILITY_ID = 'weeklyAvailableId';

export const compareDateStr = function (dateStr1, dateStr2, sformat = DATETIME_FORMAT) {
    return str2date(dateStr1, sformat) > str2date(dateStr2, sformat);
};

export const getEarliestSlotBySettings = function (card, selectedMethod, weekDayItems) {
    if (selectedMethod && selectedMethod === FIRST_AVAILABLE_ID) {
        return card.slots;
    }
    const selectedDay = weekDayItems.filter(item => item.isSelected) || [];
    const slots = card.slots || [];
    let filteredSlots = [];
    const getTime = (dateTime, hour, minute) => new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), hour, minute);
    slots.forEach(slot => {
        const slotDateTime = str2date(slot.datetime, DATETIME_FORMAT);
        let filteredSlot = null;
        selectedDay.forEach(day => {
            if (!filteredSlot && slotDateTime.getDay() === day.id) {
                const [fromHour, fromMinute] = day.fromTime.split(':');
                const [toHour, toMinute] = day.toTime.split(':');
                const fromDateTime = getTime(slotDateTime, +fromHour, +fromMinute);
                const toDateTime = getTime(slotDateTime, +toHour, +toMinute);
                if (slotDateTime.getTime() >= fromDateTime.getTime() && slotDateTime.getTime() <= toDateTime.getTime()) {
                    filteredSlot = slot;
                }
            }
        });
        if (filteredSlot) {
            filteredSlots.push(filteredSlot);
        }
    });
    return filteredSlots;
};

export const getEarliestSlotsFromCards = function (cards, selectedMethod, weekDayItems) {
    if (cards.length === 0) {
        return [];
    }
    if (cards.length === 1) {
        return getEarliestSlotBySettings(cards[0], selectedMethod, weekDayItems);
    }
    let earliestSlots;
    cards.forEach(card => {
        const slots = getEarliestSlotBySettings(card, selectedMethod, weekDayItems);
        // in case we don't have any slot in card fit with the condition
        if (!slots || slots.length === 0) {
            return;
        }
        if (!earliestSlots || (earliestSlots && compareDateStr(earliestSlots[0].datetime, slots[0].datetime))) {
            earliestSlots = slots;
        }
    });
    return earliestSlots;
};

export const parseListDateStrToStr = function (dateStrs, use24hFormat) {
    return dateStrs.map(time => {
        const datetime = str2date(time, DATETIME_FORMAT);
        return date2str(datetime, use24hFormat ? SHORT_DATETIME_FORMAT_24H : SHORT_DATETIME_FORMAT_12H);
    }).join('   ');
};

export const formatTimeWeekdayItems = function (weekDays, use24hFormat) {
    const timeFormat = use24hFormat ? SHORT_TIME_FORMAT_24H : SHORT_TIME_FORMAT_12H;
    return weekDays.map(item => {
        const fromTime = date2str(str2date(item.fromTime, TIME_FORMAT), timeFormat);
        const toTime = date2str(str2date(item.toTime, TIME_FORMAT), timeFormat);
        return {
            id: item.id,
            fullDateOfWeek: item.fullDateOfWeek,
            fromTime,
            toTime,
        };
    });
};

export const formatPhoneNumber = function (phone, specialCharacter) {
    if (!phone) {
        return '';
    }
    return phone.replace(/\d(?=\d{4})/g, specialCharacter || '*');
};
